export enum EOrganizationDetailsTabsInUrl {
  DETAILS = 'details',
  PEOPLE = 'people',
  ORGANIZATION_KITS_INVENTORY = 'organization-kits-inventory',
  NOTES = 'notes',
  OUTPUT = 'output',
}
